import { convertDate } from './convertDate';

export function convertTimeAgo(date: Date) {
  const now = new Date();

  if (!date) return null;

  //@ts-ignore
  const units: any = millisToTimeUntils(now - (date - date.getTimezoneOffset() * 60 * 1000));

  let timeString;

  if (units.year > 0) timeString = units.year === 1 ? '1 year ago' : `${units.year} years ago`;
  else if (units.month > 0) timeString = units.month === 1 ? '1 month ago' : `${units.month} months ago`;
  else if (units.week > 0) timeString = units.week === 1 ? '1 week ago' : `${units.week} weeks ago`;
  else if (units.day > 0) timeString = units.day === 1 ? '1 day ago' : `${units.day} days ago`;
  else if (units.hour > 0) timeString = units.hour === 1 ? '1 hour ago' : `${units.hour} hours ago`;
  else timeString = `${units.minute} mins ago`;

  return timeString;
}

export function millisToTimeUntils(millis) {
  let d = Math.abs(millis) / 1000;
  const r = {};

  const s = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  };

  Object.keys(s).forEach(key => {
    r[key] = Math.floor(d / s[key]);
    d -= r[key] * s[key];
  });

  return r;
}
